/** Error codes returned in `{ error: { code } }`. Clients switch on these, never on messages. */
export const ERROR_CODES = Object.freeze({
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  RATE_LIMITED: 'RATE_LIMITED',
  INTERNAL: 'INTERNAL',

  AUTH_REQUIRED: 'AUTH_REQUIRED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  SESSION_REVOKED: 'SESSION_REVOKED',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
  PASSWORD_NOT_SET: 'PASSWORD_NOT_SET',
  PASSWORD_CHANGE_REQUIRED: 'PASSWORD_CHANGE_REQUIRED',
  INVALID_TOKEN: 'INVALID_TOKEN',
  CSRF_INVALID: 'CSRF_INVALID',
  FORBIDDEN: 'FORBIDDEN',
  IP_NOT_ALLOWED: 'IP_NOT_ALLOWED',
  MFA_INVALID: 'MFA_INVALID',
  OVERRIDE_INVALID: 'OVERRIDE_INVALID',

  DEVICE_REQUIRED: 'DEVICE_REQUIRED',
  DEVICE_REVOKED: 'DEVICE_REVOKED',
  ACTIVATION_CODE_INVALID: 'ACTIVATION_CODE_INVALID',
  PIN_LOCKED: 'PIN_LOCKED',

  LICENSE_SUSPENDED: 'LICENSE_SUSPENDED',
  LICENSE_EXPIRED: 'LICENSE_EXPIRED',
  LICENSE_READ_ONLY: 'LICENSE_READ_ONLY',
  READ_ONLY_SESSION: 'READ_ONLY_SESSION',
  COMING_SOON: 'COMING_SOON',
  BUSY: 'BUSY',
  LIMIT_REACHED: 'LIMIT_REACHED',
  FEATURE_DISABLED: 'FEATURE_DISABLED',
  KITCHEN_OFF: 'KITCHEN_OFF',
  OUTLET_REQUIRED: 'OUTLET_REQUIRED',
});
